import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bcrm-exe-targets',
  templateUrl: './bcrm-exe-targets.component.html',
  styleUrls: ['./bcrm-exe-targets.component.scss']
})
export class BcrmExeTargetsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
